/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources/:source_id/test_connection" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiSourcesSourceIdTestConnectionCacheKeys } from "./constants";
import type { PostIntegrationsDirectCdiSourcesSourceIdTestConnectionProps, TestConnectionResult } from "./types";

export const postIntegrationsDirectCdiSourcesSourceIdTestConnection = reactQueryMutationAdapter(
  postIntegrationsDirectCdiSourcesSourceIdTestConnectionCacheKeys,
  (props: PostIntegrationsDirectCdiSourcesSourceIdTestConnectionProps): Promise<TestConnectionResult> => {
    return fetch(`/integrations/direct/cdi/sources/${props.sourceId}/test_connection`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
